import React from 'react';
import {
  emptyServiceQuote,
  newPricedTask,
  quoteTotal,
} from '../utils/servicePricing';

export default function ServicePricingFields({
  serviceName,
  quote,
  onChange,
}) {
  const q = quote || emptyServiceQuote();
  const byTask = q.linePricingMode === 'task';

  const setQuote = (patch) => onChange({ ...q, ...patch });

  const updateTask = (taskId, field, value) => {
    setQuote({
      tasks: (q.tasks || []).map((task) =>
        task.id === taskId ? { ...task, [field]: value } : task,
      ),
    });
  };

  return (
    <div className="qf-service-pricing">
      <div className="qf-pricing-mode" role="group" aria-label="Pricing mode">
        <button
          type="button"
          className={`qf-mode-btn${!byTask ? ' is-active' : ''}`}
          onClick={() => setQuote({ linePricingMode: 'service' })}
        >
          Price by service
        </button>
        <button
          type="button"
          className={`qf-mode-btn${byTask ? ' is-active' : ''}`}
          onClick={() => setQuote({ linePricingMode: 'task' })}
        >
          Price by task
        </button>
      </div>
      {!byTask ? (
        <div className="qf-service-price-row">
          <label>
            Service price
            <input
              type="number"
              min="0"
              step="0.01"
              value={q.price}
              onChange={(e) => setQuote({ price: e.target.value })}
              placeholder="0.00"
            />
          </label>
          <label>
            Disc %
            <input
              type="number"
              min="0"
              max="100"
              step="0.01"
              value={q.discount}
              onChange={(e) => setQuote({ discount: e.target.value })}
            />
          </label>
          <span className="qf-service-amount">
            {quoteTotal(q).toFixed(2)}
          </span>
        </div>
      ) : (
        <div className="qf-project-task-list">
          {(q.tasks || []).map((task) => (
            <div className="qf-project-task-row" key={task.id}>
              <input
                value={task.title || ''}
                placeholder={`${serviceName || 'Task'} name`}
                onChange={(e) => updateTask(task.id, 'title', e.target.value)}
              />
              <input
                type="number"
                min="0"
                step="0.01"
                value={task.price ?? ''}
                placeholder="Price"
                onChange={(e) => updateTask(task.id, 'price', e.target.value)}
              />
              <input
                type="number"
                min="0"
                max="100"
                step="0.01"
                value={task.discount ?? '0'}
                placeholder="Disc %"
                onChange={(e) =>
                  updateTask(task.id, 'discount', e.target.value)
                }
              />
              <button
                type="button"
                className="qf-task-remove"
                aria-label="Remove task"
                onClick={() =>
                  setQuote({
                    tasks: (q.tasks || []).filter((row) => row.id !== task.id),
                  })
                }
              >
                ✕
              </button>
            </div>
          ))}
          <button
            type="button"
            className="qf-add-task"
            onClick={() =>
              setQuote({
                tasks: [...(q.tasks || []), newPricedTask('')],
              })
            }
          >
            ＋ Add task
          </button>
        </div>
      )}
    </div>
  );
}
